'use strict';

import surveyTemplate from './decipherSurvey.html';
import { forIn, indexOf } from 'lodash';

var decipherSurveyController = function ($controller, $window, $location, workflowService) {
    var vm = this;
    vm.executionStep = null;

    angular.extend(vm, $controller('baseStepController'));

    vm.$onInit = function () {
        vm.initializeStep(vm.$stateParams).then(function (executionStep) {
            vm.executionStep = executionStep;
            vm.showSurvey();
        });
    };

    vm.showSurvey = function () {
        getDecipherUrl().then(url => {
            $window.location.href = url;
        });
    };

    function getDecipherUrl() {
        var ticketStep = vm.executionStep.ticketStep;
        var parameters = ticketStep.parameters;
        var listId = findAndRemove("listId", parameters);
        var url = findAndRemove("surveyUrl", parameters);

        url = url + "?list=" + listId + "&ticketId=" + ticketStep.ticketId + "&stepId=" + ticketStep.stepId + "&ticketStepId=" + ticketStep.id + "&baseRedirectUrl=" + getRedirectUrl();

        //add ticket step parameters
        for (var i = 0; i < parameters.length; i++) {
            url = url + "&" + encodeURIComponent(parameters[i].argumentName) + "=" + parameters[i].value;
        }

        //add ticket parameters (panel respondent identifiers)
        return workflowService.getTicket(vm.executionStep.ticketStep.ticketId).then((ticket) => {
            var allowedTicketParameters = ['sid', 'rid', 'ac', 'transaction_id', 'mid', 'psid', 'icsid', 'pid', 'k2', 'med', 'declang', 'id', 'tk', 'gid', 'sname'];

            // Add panel keys to allowed parameters if panel exists
            if (ticket.panel && ticket.panel.getKeys) {
                var panelKeys = ticket.panel.getKeys();
                panelKeys.forEach(function (key) {
                    var lowerKey = key.toLowerCase();
                    if (allowedTicketParameters.indexOf(lowerKey) === -1) {
                        allowedTicketParameters.push(lowerKey);
                    }
                });
            }

            forIn(ticket.parameters, (value, key) => {
                if (indexOf(allowedTicketParameters, key.toLowerCase()) !== -1) {
                    url = url + "&" + encodeURIComponent(key) + "=" + value;
                }
            });

            return url;
        });
    }

    function findAndRemove(parameter, parameters) {
        for (var i = 0; i < parameters.length; i++) {
            if (parameters[i].argumentName.toLowerCase() === parameter.toLowerCase()) {
                var value = parameters[i].value;
                parameters.splice(i, 1);
                return value;
            }
        }

        return -1;
    }

    function getRedirectUrl() {
        return encodeURIComponent($location.protocol() + '://' + $location.host() + ':' + $location.port() + '/');
    }
};

decipherSurveyController.$inject = ['$controller', '$window', '$location', 'workflowService'];

export var decipherSurveyComponent = {
    name: 'decipherSurvey',
    template: surveyTemplate,
    controller: decipherSurveyController,
    controllerAs: 'vm',
    bindings: {
        $stateParams: '<'
    }
};

export var decipherSurveyRoute = {
    name: 'decipherSurvey',
    url: '/deciphersurvey',
    component: 'decipherSurvey'
};
